export default {"src":"/_next/static/image/public/icons/control/chevron-right.db082a82700f46a2337ee5350e07c04c.svg","height":19,"width":11};